import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Header, Titulo} from '../elementos/Header'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioMaterial from './FormularioMaterial'
import favicon from '../imagenes/logoutm.png'

const RegistroMaterial = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                        <title>Registro de Material</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <Header>
                    <Titulo>Registro de Material</Titulo>
                    <BtnRegresar ruta="/material"/>
            </Header>

            <FormularioMaterial />
        </>
    );
}
 
export default RegistroMaterial;